import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((Theme) => ({
  resultsSection: {
    flexDirection: 'row',
    height: 'calc(100% - 100px)',
    marginBottom: '-40px',
    [Theme.breakpoints.up('lg')]: {
      paddingLeft: '25px',
    },
  },
  resultsHeader: {},
  selectFlightHeader: {
    color: Theme.palette.primary.main,
    fontFamily: Theme.typography.base.semiBold,
    fontSize: Theme.typography.size[9],
    lineHeight: '150%',
    [Theme.breakpoints.down('lg')]: {
      fontSize: Theme.typography.size[7],
    },
    [Theme.breakpoints.down('sm')]: {
      fontSize: Theme.typography.size[6],
    },
  },
  descriptionFlightHeader: {
    color: Theme.palette.gray[750],
    fontFamily: Theme.typography.base.regular,
    fontSize: Theme.typography.size[3],
    lineHeight: '145%',
    [Theme.breakpoints.down('lg')]: {
      fontSize: Theme.typography.size[2],
    },
  },
  resultsContent: {},
  resultsFilterMenu: {
    display: 'none',
    [Theme.breakpoints.down('md')]: {
      display: 'inline-flex',
      flexGrow: '1',
    },
    '& > button': {
      margin: '0',
    },
  },
  openFiltersButton: {
    color: Theme.palette.gray[750],
    lineHeight: '150%',
    fontSize: Theme.typography.size[2],
  },
  resultsFilterMenuIcon: {
    color: Theme.palette.primary.light,
    marginLeft: '0 !important',
    marginRight: '9px',
    height: '26px !important',
    width: '26px',
  },
  resultsActions: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  resultsFlightsNumber: {
    fontSize: Theme.typography.size[2],
    lineHeight: '150%',
    color: Theme.palette.gray[750],
  },
  resultsSorting: {
    float: 'right',
    color: Theme.palette.gray[750],
    fontSize: Theme.typography.size[2],
    lineHeight: '150%',
    marginRight: '0',
    marginLeft: 'auto',
    [Theme.breakpoints.down('md')]: {
      marginLeft: '20px',
    },
    [Theme.breakpoints.down('sm')]: {
      '& > span': {
        display: 'none',
      },
    },
  },
  sortingDropdown: {
    display: 'inline-block',

    '& > div > button': {
      margin: '0',
      fontFamily: Theme.typography.base.regular,
      fontSize: Theme.typography.size[2],
      color: Theme.palette.primary.light,
    },
  },
  formatedDate: {
    color: Theme.palette.gray[750],
    textTransform: 'capitalize',
    marginBottom: '22px',
    fontSize: Theme.typography.size[3],
    lineHeight: '150%',
    fontFamily: Theme.typography.base.semiBold,
  },
}));

export default useStyles;
